import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import SelectInvoiceUnitsMeasurement from 'Components/Organisms/SelectInvoiceUnitsMeasurement/SelectInvoiceUnitsMeasurement';

export default function RHFSelectInvoiceUnitsMeasurement({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <SelectInvoiceUnitsMeasurement {...field} error={error?.message} {...other} />
            )}
        />
    );
}

RHFSelectInvoiceUnitsMeasurement.propTypes = {
    name: PropTypes.string,
};
